import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import projectsData from '../data/projects.json'; // Adjust path as needed

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Custom styles to override default Swiper colors to match your Emerald theme
// You can also put this in your global CSS
const swiperStyleOverrides = {
  "--swiper-navigation-color": "#10b981", // Emerald-500
  "--swiper-pagination-color": "#10b981", // Emerald-500
  "--swiper-navigation-size": "24px",
};

const ProjectsSlider = () => {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        
        {/* --- Header Section --- */}
        <div className="flex justify-between items-end mb-16">
          <div>
            <h2 className="text-emerald-700 font-bold uppercase tracking-widest text-sm mb-4">
              Referenzen
            </h2>
            <h3 className="text-4xl md:text-5xl font-black">Aktuelle Projekte.</h3>
          </div>
          
          {/* Desktop "View All" Button */}
          <Link 
            to="/Project" 
            className="hidden sm:flex items-center gap-2 font-black text-slate-900 border-b-2 border-emerald-500 pb-1 hover:text-emerald-700 transition-colors"
          >
            ALLE PROJEKTE ANSEHEN
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          </Link>
        </div>

        {/* --- Slider Section --- */}
        <div>
          {projectsData.length === 0 ? (
            <p className="text-center text-gray-500">Keine Projekte gefunden.</p>
          ) : (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={40} // Equivalent to gap-10
              slidesPerView={1} // Default mobile
              navigation={true}
              pagination={{ clickable: true }}
              style={swiperStyleOverrides}
              className="pb-12" // Padding bottom for pagination dots
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3, // Desktop matches original grid
                  spaceBetween: 40,
                },
              }}
            >
              {projectsData.map((proj) => (
                <SwiperSlide key={proj.id}>
                  <Link to={`/project/${proj.id}`} className="group block h-full">
                    {/* Image Container */}
                    <div className="bg-gray-100 h-[400px] w-full mb-6 overflow-hidden rounded-lg relative">
                      <img 
                        src={proj.image} 
                        alt={proj.title} 
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-in-out" 
                      />
                      {/* Optional Overlay on Hover */}
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
                    </div>

                    {/* Text Content */}
                    <div className="flex flex-col">
                      <h4 className="text-2xl font-bold text-slate-900 group-hover:text-emerald-700 transition-colors">
                        {proj.title}
                      </h4>
                      <p className="text-gray-500 mt-2 font-medium">
                        {proj.category}
                      </p>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>

      </div>
    </section>
  );
};

export default ProjectsSlider;